// extracted by mini-css-extract-plugin
export var navbarSubLink = "Q_gb d_gb d_f4 d_Z d_cb d_dl d_br d_bS";
export var menuLink = "Q_wn d_f0 d_dz";
export var subPageLink = "Q_gf d_gf";
export var burger = "Q_wL";
export var sublinkSize = "Q_wM";
export var linkSize = "Q_wN";
export var Link = "Q_s8 B_s8 B_sq B_sL";